import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { getServerStatus } from '../api/auth'
import { PasskeyButton } from '../components/Auth/PasskeyButton'
import { useAuthStore } from '../store/auth'

export function Login() {
  const [username, setUsername] = useState('')
  const [error, setError] = useState('')
  const [registrationEnabled, setRegistrationEnabled] = useState(false)
  const navigate = useNavigate()
  const currentUser = useAuthStore((s) => s.username)

  useEffect(() => {
    getServerStatus()
      .then((s) => setRegistrationEnabled(s.registration_enabled))
      .catch(() => {})
  }, [])

  if (currentUser) {
    navigate(`/~${currentUser}/journal`)
    return null
  }

  return (
    <div style={{ maxWidth: 400, margin: '4rem auto' }}>
      <h1>login</h1>
      <br />
      {error && <p style={{ color: 'var(--color-1)', marginBottom: '1rem' }}>{error}</p>}
      <label>
        username
        <input value={username} onChange={(e) => setUsername(e.target.value)} />
      </label>
      <br />
      <br />
      <PasskeyButton
        username={username}
        mode="login"
        onSuccess={() => navigate(`/~${username}/journal`)}
        onError={setError}
      />
      {registrationEnabled && (
        <p style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
          new here? <Link to="/register">create an account</Link>
        </p>
      )}
    </div>
  )
}
